module.exports = __webpack_public_path__ + "img/desk3.23f4cf4e.png";